import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-update-email',
	templateUrl: './update-email.component.html',
	styleUrls: [ './update-email.component.scss' ]
})
export class UpdateEmailComponent implements OnInit, OnDestroy {
	isCanceled: boolean = true;
	isSubmitted: boolean = false;
	email: string;

	private subscription: Subscription = new Subscription();

	formGroup: FormGroup = new FormBuilder().group({
		email: [
			null,
			Validators.compose([ Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$') ])
		]
	});

	constructor(public bsModalRef: BsModalRef) {
		const formChangeSubs = this.formGroup.get('email').valueChanges.subscribe((value) => {
			this.formGroup.get('email').markAsDirty();
			this.formGroup.get('email').markAsTouched();
			//this.formGroup.get('email').updateValueAndValidity();
		});
	}

	ngOnInit() {
		this.formGroup.get('email').patchValue(this.email);
		const subs = this.formGroup.get('email').valueChanges.subscribe((value) => (this.email = value));
		this.subscription.add(subs);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onCancel() {
		this.isCanceled = true;
		this.bsModalRef.hide();
	}

	onSubmit() {
		this.isCanceled = false;
		this.isSubmitted = true;
		this.bsModalRef.hide();
	}
}
